import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import VegFoodBenefitsBanner from '../../assets/veg-food-benefits-banner.jpg';
import { getDeviceType } from '../../utils/common';
import { pageAction } from '../../redux_files/actions/page_actions';

const VegFoodBenefits = () => {
	const dispatch = useDispatch();
	const [deviceType, setDeviceType] = useState(getDeviceType());
	useEffect(() => {
		window.addEventListener('resize', setDeviceType(getDeviceType()));
		return () => window.removeEventListener('resize', setDeviceType(getDeviceType()));
	}, []);

	useEffect(() => {
		document.title = 'Blogs | Benefits of Veg Food';
		dispatch(pageAction('Veg Food Benefits'));
	});
	return (
		<>
			<img src={VegFoodBenefitsBanner} alt='Banner' width='100%' height={deviceType !== "mobile" ? "480" : "200"} />
			<div className='container'>

				<article>
					{deviceType === "mobile" ? <h3>Top Benefits of Eating Pure Vegetarian Food</h3> : <h2>Top Benefits of Eating Pure Vegetarian Food</h2>}

					<h2>Top Benefits of Eating Pure Vegetarian Food</h2>

  <p><strong>1. Rich in Nutrients:</strong> Vegetarian diets are full of vitamins, minerals, fiber, and antioxidants. Foods like vegetables, fruits, legumes, whole grains, and nuts are naturally nutrient-dense.</p>
  
  <p><strong>2. Supports Heart Health:</strong> Pure veg diets are typically lower in saturated fats and cholesterol. They may help lower blood pressure, improve cholesterol levels, and reduce the risk of heart disease.</p>
  
  <p><strong>3. Aids Digestion:</strong> High fiber content in vegetarian meals promotes better digestion, prevents constipation, and supports gut health.</p>
  
  <p><strong>4. Reduces Risk of Chronic Diseases:</strong> Studies suggest that a vegetarian diet may help prevent or manage Type 2 Diabetes, certain cancers (like colon cancer), and obesity.</p>
  
  <p><strong>5. Promotes a Healthy Weight:</strong> Vegetarian diets often lead to healthier body weight due to lower calorie intake and higher fiber levels that increase satiety.</p>
  
  <p><strong>6. Environmentally Friendly:</strong> Producing plant-based food uses less water, land, and energy. A pure veg diet has a lower carbon footprint, contributing to a sustainable planet.</p>
  
  <p><strong>7. Ethical and Compassionate:</strong> Avoids harm to animals, aligning with principles of non-violence (Ahimsa) and compassion.</p>
  
  <p><strong>8. Improves Skin and Overall Vitality:</strong> Nutrient-rich plant foods support clearer skin, stronger hair, and improved energy levels.</p>
				</article>
			</div>
		</>
	);
};
export default VegFoodBenefits;

